"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGINATION
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)


var _default = {
  standardpagination: {
    width: 'fit-content',
    display: 'flex',
    flexWrap: 'nowrap',
    marginRight: 'auto',
    marginLeft: 'auto',
    '& .arrow': {
      background: (0, _index.convertHexToRGB)(_index.theme.color.supporting.dark.swatch, 5),
      color: _index.theme.color.primary.medium.swatch,
      cursor: 'pointer',
      borderRadius: (0, _index.pxToEm)(4),
      display: 'inline-flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: (0, _index.pxToEm)(36),
      width: (0, _index.pxToEm)(36),
      //padding: pxToEm(10),
      marginLeft: (0, _index.pxToEm)(5),
      transition: 'all .15s linear 0s',
      '&:hover': {
        filter: 'brightness(35%)'
      },
      '&.disabled': {
        '&-true': {
          // background: convertHexToRGB(theme.color.supporting.dark.swatch, 2),
          color: _index.theme.color.grey.medium.swatch,
          cursor: 'default',
          pointerEvents: 'none'
        }
      }
    },
    '& .status': {
      // margin: replacePXinStringWithEM(`0px 20px`),
      display: 'inline-flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      margin: "0 ".concat((0, _index.pxToEm)(10))
    },
    '& .display': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .total': {
      marginLeft: (0, _index.pxToEm)(5)
    }
  }
};
exports.default = _default;